import React from 'react';
import './App.css';
import Root from './modules/Root/container/Root'
import SessionGate from './modules/Auth/container/SessionGate'

function App() {
  return (
    <SessionGate>
      <Root/>
    </SessionGate>
  );
}

export default App;
